var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsulting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.288,
    height: 33.57,
    viewBox: "0 0 25.288 33.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF",
    transform: "translate(-0.25 -0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12582",
    "data-name": "Path 12582",
    d: "M24.788,20.613V2.126A1.161,1.161,0,0,0,23.661,1H2.126A1.161,1.161,0,0,0,1,2.126V31.944A1.161,1.161,0,0,0,2.126,33.07h15.9l6.759-7.024Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19934",
    "data-name": "Group 19934",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    transform: "translate(23.788 22.33)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12583",
    "data-name": "Path 12583",
    d: "M28.06,38.8h5.5L27,45.824V39.86A1.09,1.09,0,0,1,28.06,38.8Z",
    transform: "translate(-9.772 -13.753)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12584",
    "data-name": "Path 12584",
    d: "M24.788,20.613V2.126A1.161,1.161,0,0,0,23.661,1H2.126A1.161,1.161,0,0,0,1,2.126V31.944A1.161,1.161,0,0,0,2.126,33.07h15.9",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 18.023,
    transform: "translate(2.915 15.107)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 18.023,
    transform: "translate(2.915 20.077)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 9.807,
    transform: "translate(2.915 25.047)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12585",
    "data-name": "Path 12585",
    d: "M16.769,13.226H7.228A.906.906,0,0,1,6.3,12.3V7.528A.906.906,0,0,1,7.228,6.6h9.542a.906.906,0,0,1,.928.928V12.3A1,1,0,0,1,16.769,13.226Z",
    transform: "translate(-2.788 -2.889)",
    fill: "none",
    stroke: "#045195",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting);
export default __webpack_public_path__ + "static/media/consulting.0a136463f7f460720c8329166fb9a9fa.svg";
export { ForwardRef as ReactComponent };